// extracted by mini-css-extract-plugin
module.exports = {"tooltipWrapper":"styles_tooltipWrapper__4tQOX"};